import React from 'react';
import { TerminalIcon } from 'lucide-react';
import { profile } from '../data/profile';
import { SectionHeading } from './SectionHeading';
const answers = [{
  q: '¿Qué hago todos los días?',
  a: 'Infraestructura IT y soporte técnico: servidores Linux y VPS, hosting, dominios, DNS, HTTPS y SSL/TLS, redes con OpenWRT y Ubiquiti, virtualización, diagnóstico y reparación de hardware. Más de diez años resolviendo problemas reales, no ejercicios.'
}, {
  q: '¿De dónde salen los proyectos?',
  a: 'De necesidades propias. Querer prender la PC de casa estando afuera, migrar los puntos de una comunidad de stream, saber si un sitio está rindiendo. Primero lo necesito yo; después lo documento y lo publico.'
}, {
  q: '¿Hasta dónde llega el rango?',
  a: 'Bajo y alto nivel en la misma semana: firmware en C++ sobre ESP32, workers en JavaScript sobre Cloudflare, integraciones en C# para Streamer.bot, sitios en Astro y diagnóstico electrónico automotriz con OBD-II.'
}];
const facts: [string, string][] = [['nombre', 'Pablo S. Marchetti Orayen'], ['alias', profile.aliases.join(' · ')], ['rol', 'Infraestructura IT · Linux · Redes'], ['base', 'Villars, Buenos Aires, AR'], ['público', 'desde junio de 2026'], ['licencia', 'GPL-3.0']];
export function Identity() {
  return <section id="quien-soy" className="border-b border-hairline py-24 lg:py-32" data-id="element-103" data-mp="2ixnq2b8oc8el">
      <div className="mx-auto max-w-6xl px-6" data-id="element-104" data-mp="2nwh1ly4ehpc4">
        <div className="grid gap-16 lg:grid-cols-[minmax(0,420px)_minmax(0,1fr)]" data-id="element-105" data-mp="2ntl3o9sjz0no">
          <div data-id="element-106" data-mp="2st7i2mk4amy2">
            <SectionHeading index="01 — Quién soy" title="Un lab de una sola persona" data-id="element-107" data-mp="2ssny70awpohe" />
            <div className="mt-8 rounded-xl border border-hairline bg-panel p-5 font-mono text-[13px] leading-relaxed" data-id="element-108" data-mp="2xmacewwpy0fb">
              <div className="flex items-center gap-2 text-ink-mid" data-id="element-109" data-mp="31owvo9fbqd0w">
                <TerminalIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-110" data-mp="36nqe8g9gwu7x" />
                <span data-id="element-111" data-mp="3bmbdacczh7us">whoami</span>
              </div>
              <dl className="mt-4 space-y-2" data-id="element-112" data-mp="3bix7sv90wij4">
                {facts.map(([k, v]) => <div key={k} className="flex gap-3" data-id="element-113" data-mp="1bgxsv9lzpdcq">
                    <dt className="w-20 shrink-0 text-teal" data-id="element-114" data-mp="16kyuquav0gz4">{k}</dt>
                    <dd className="text-ink-hi" data-id="element-115" data-mp="1l8jzesnduo95">{v}</dd>
                  </div>)}
              </dl>
            </div>
            <a href={profile.portfolio} target="_blank" rel="noreferrer" className="mt-4 inline-block font-mono text-xs text-ink-mid underline decoration-hairline underline-offset-4 transition-colors duration-150 ease-out hover:text-teal focus:outline-none focus-visible:ring-2 focus-visible:ring-teal" data-id="element-116" data-mp="1gh270szfdvzs">
              Ver portfolio completo, experiencia y certificaciones ↗
            </a>
          </div>

          <dl className="space-y-9" data-id="element-117" data-mp="9t51nmncnscz">
            {answers.map(item => <div key={item.q} className="border-l border-hairline pl-6" data-id="element-118" data-mp="4uk11m46r6o0">
                <dt className="font-mono text-base font-medium text-ink-hi" data-id="element-119" data-mp="4wemd1jdd0sm">{item.q}</dt>
                <dd className="mt-2.5 max-w-2xl leading-relaxed text-ink-mid" data-id="element-120" data-mp="2gifg2ay2k375">{item.a}</dd>
              </div>)}
          </dl>
        </div>
      </div>
    </section>;
}